import { breakpoints } from 'styles/mediaQueries'
import { useAppSelector } from './hooks'

export const isTabletWidth = () =>
    window.screen.width < breakpoints.xl || window.innerWidth < breakpoints.xl

export const isSmallTabletWidth = () =>
    window.screen.width < breakpoints.lg || window.innerWidth < breakpoints.lg

export const isMobileWidth = () =>
    window.screen.width < breakpoints.md || window.innerWidth < breakpoints.md

export const isCustomDevice = (customWidth: number) =>
    window.screen.width < customWidth || window.innerWidth < customWidth

export const useResolutions = () => {
    const isTablet = useAppSelector((state) => state.general.isTablet)
    const isSmallTablet = useAppSelector((state) => state.general.isSmallTablet)
    const isMobile = useAppSelector((state) => state.general.isMobile)

    return { isTablet, isSmallTablet, isMobile }
}
